/**
 * StudyPass Academy - Subject Configuration
 *
 * Central configuration for all dental hygiene subjects.
 * exam: 'nbdhe' = National Board Dental Hygiene Exam (12 subjects)
 * exam: 'la-board' = Written Local Anesthesia Board Exam (1 subject)
 */

export const SUBJECTS = [
  {
    id: 'radiology',
    name: 'Radiology',
    icon: '🩻',
    description: 'X-rays, imaging techniques, radiation safety, and diagnostic imaging',
    color: 'from-blue-400 to-blue-600',
    hasStudyGuides: true,
    hasFlashcards: true,
    hasVideos: false,
    questionCount: 250,
    exam: 'nbdhe',
    wixId: '890685cb-07bf-4ff0-9a40-a5cb8b77379d'
  },
  {
    id: 'local-anesthesia',
    name: 'Local Anesthesia',
    icon: '💉',
    description: 'Anesthetic agents, injection techniques, and pain management',
    color: 'from-purple-400 to-purple-600',
    hasStudyGuides: true,
    hasFlashcards: false,
    hasVideos: true,
    questionCount: 280,
    exam: 'la-board',
    wixId: '411fd570-e05e-4859-a1a8-2ff7fef6a7de'
  },
  {
    id: 'nutrition',
    name: 'Nutrition',
    icon: '🍎',
    description: 'Dietary guidelines, vitamins, minerals, deficiencies, and nutritional health',
    color: 'from-green-400 to-green-600',
    hasStudyGuides: true,
    hasFlashcards: false,
    hasVideos: true,
    questionCount: 180,
    exam: 'nbdhe',
    wixId: '1504373e-aaea-4a07-96e6-6e42f9a1368e'
  },
  {
    id: 'microbiology-immunology',
    name: 'Microbiology & Immunology',
    icon: '🦠',
    description: 'Bacteria, viruses, immune system, and infection control',
    color: 'from-red-400 to-red-600',
    hasStudyGuides: true,
    hasFlashcards: false,
    hasVideos: false,
    questionCount: 220,
    exam: 'nbdhe',
    wixId: '0032d96f-160c-4c5a-ad2f-14725ae3358a'
  },
  {
    id: 'medical-emergencies',
    name: 'Medical Emergencies & Special Needs Patients',
    icon: '🚨',
    description: 'Emergency protocols, CPR, and care for special populations',
    color: 'from-orange-400 to-orange-600',
    hasStudyGuides: true,
    hasFlashcards: false,
    hasVideos: false,
    questionCount: 200,
    exam: 'nbdhe',
    wixId: '8ce32a63-a722-46bc-abbe-79f972c55a63'
  },
  {
    id: 'pathology',
    name: 'Pathology',
    icon: '🔬',
    description: 'General and oral diseases, lesions, and pathological conditions',
    color: 'from-pink-400 to-pink-600',
    hasStudyGuides: true,
    hasFlashcards: true,
    hasVideos: true,
    questionCount: 240,
    exam: 'nbdhe',
    wixId: '0bca34f8-4c73-4e57-b362-014cd2953b54'
  },
  {
    id: 'pharmacology',
    name: 'Pharmacology',
    icon: '💊',
    description: 'Drug classifications, interactions, and medication management',
    color: 'from-indigo-400 to-indigo-600',
    hasStudyGuides: true,
    hasFlashcards: false,
    hasVideos: true,
    questionCount: 260,
    exam: 'nbdhe',
    wixId: '4edead71-5f8a-4d2a-a98b-23b771ad79af'
  },
  {
    id: 'anatomy',
    name: 'Anatomy',
    icon: '💀',
    description: 'Head, neck, and oral anatomy structures and functions',
    color: 'from-cyan-400 to-cyan-600',
    hasStudyGuides: true,
    hasFlashcards: true,
    hasVideos: false,
    questionCount: 300,
    exam: 'nbdhe',
    wixId: '58549a62-3343-4861-81ab-4a9ea6f965ff'
  },
  {
    id: 'dental-hygiene-sciences',
    name: 'Dental Hygiene Sciences',
    icon: '🪥',
    description: 'Preventive care, oral hygiene techniques, instrumentation, and patient education',
    color: 'from-teal-400 to-teal-600',
    hasStudyGuides: true,
    hasFlashcards: false,
    hasVideos: true,
    questionCount: 270,
    exam: 'nbdhe',
    wixId: '0b116ed5-c896-4df7-869a-70a76bb168a5'
  },
  {
    id: 'dental-materials',
    name: 'Dental Materials',
    icon: '👑',
    description: 'Restorative materials, cements, and dental product properties',
    color: 'from-yellow-400 to-yellow-600',
    hasStudyGuides: true,
    hasFlashcards: true,
    hasVideos: true,
    questionCount: 190,
    exam: 'nbdhe',
    wixId: 'd5f51db8-0973-4a62-be7b-f71c5d439fdb'
  },
  {
    id: 'ethics',
    name: 'Ethics',
    icon: '⚖️',
    description: 'Professional ethics, legal considerations, and practice standards',
    color: 'from-gray-400 to-gray-600',
    hasStudyGuides: true,
    hasFlashcards: true,
    hasVideos: true,
    questionCount: 150,
    exam: 'nbdhe',
    wixId: '96325ec3-8ef6-4799-b42b-9e81da574530'
  },
  {
    id: 'community',
    name: 'Community',
    icon: '🏘️',
    description: 'Community health, public health dentistry, and epidemiology',
    color: 'from-lime-400 to-lime-600',
    hasStudyGuides: true,
    hasFlashcards: false,
    hasVideos: true,
    questionCount: 170,
    exam: 'nbdhe',
    wixId: '982d9fc3-c0cb-4c75-b194-dc489047ed72'
  },
  {
    id: 'periodontology',
    name: 'Periodontology',
    icon: '🦷',
    description: 'Periodontal diseases, treatments, and gingival health',
    color: 'from-rose-400 to-rose-600',
    hasStudyGuides: true,
    hasFlashcards: false,
    hasVideos: true,
    questionCount: 230,
    exam: 'nbdhe',
    wixId: 'e656b92d-044f-4b5c-a346-d77e176c2250'
  }
];

/**
 * Get subject by ID
 * @param {string} id - Subject ID (e.g., 'radiology')
 * @returns {object|null} Subject object or null if not found
 */
export const getSubjectById = (id) => {
  return SUBJECTS.find(subject => subject.id === id) || null;
};

/**
 * Get subject by Wix ID (for data migration/mapping)
 * @param {string} wixId - Wix UUID
 * @returns {object|null} Subject object or null if not found
 */
export const getSubjectByWixId = (wixId) => {
  return SUBJECTS.find(subject => subject.wixId === wixId) || null;
};

/**
 * Get all subjects with specific resource availability
 * @param {string} resourceType - 'hasStudyGuides' | 'hasFlashcards' | 'hasVideos'
 * @returns {array} Array of subjects with that resource
 */
export const getSubjectsWithResource = (resourceType) => {
  return SUBJECTS.filter(subject => subject[resourceType]);
};

/**
 * Get total question count across all subjects
 * @returns {number} Total questions
 */
export const getTotalQuestionCount = () => {
  return SUBJECTS.reduce((total, subject) => total + subject.questionCount, 0);
};
